<template>
  <tr>
    <DoctorSpecialitiesDialog ref="specialitiesDialog" v-model="res" :speciality-options="specialityOptions"/>
    <td :class="{'selected': hasDiffs && oldAsText === resAsText}" style="padding: 0 5px;">
      <span style="cursor: pointer;" @click="res = JSON.parse(JSON.stringify(o))" v-if="hasDiffs">
        {{oldAsText}}
      </span>
    </td>
    <td style="padding: 0 5px;">
      <table style="width: 100%">
        <tr>
          <td valign="top">
            <div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div>
          </td>
          <td width="100%">
            <div class="specField" @click.prevent="openSpecDialog"> {{resAsText}}</div>
          </td>
          <td valign="top" v-html="suffix"></td>
        </tr>
      </table>
    </td>
    <td :class="{'selected': hasDiffs && newAsText === resAsText}" style="padding: 0 5px;">
      <span style="cursor: pointer;" @click="res = JSON.parse(JSON.stringify(n))" v-if="hasDiffs">
        {{newAsText}}
      </span>
    </td>
  </tr>
</template>
<script>
import Base from "../Base.vue";
import _ from "lodash";
import DoctorSpecialitiesDialog from "@dialogs/common/doctors/DoctorSpecialitiesDialog.vue";
import {mapState} from "vuex";

export default {
  components: {DoctorSpecialitiesDialog},
  mixins: [Base],
  props: {
    o: {
      type: [Array],
      default: ''
    },
    n: {
      type: [Array],
      default: ''
    },
    f: {
      type: [Array],
      default: ''
    },
  },
  data: function () {
    return {
      prefix: this.params.prefix ?? '',
      suffix: this.params.suffix ? "&nbsp;" + this.params.suffix : '',
      output: this.params.output ?? 'input',
    }
  },
  methods: {
    openSpecDialog () {
      this.$refs.specialitiesDialog.$refs.dialog.show();
    }
  },
  computed: {
    ...mapState({
      specialityOptions: state => state.dictionary.specialityOptions,
    }),
    resAsText() {
      let resultText = [];
      this.res.forEach((specId) => {
        let match = this.specialityOptions.find(item => item.value === specId)
        if (match && match.text) {
          resultText.push(match.text)
        }
      })
      return resultText.join(', ');
    },
    oldAsText() {
      let resultText = [];
      this.o.forEach((specId) => {
        let match = this.specialityOptions.find(item => item.value === specId)
        if (match && match.text) {
          resultText.push(match.text)
        }
      })
      return resultText.join(', ');
    },
    newAsText() {
      let resultText = [];
      this.n.forEach((specId) => {
        let match = this.specialityOptions.find(item => item.value === specId)
        if (match && match.text) {
          resultText.push(match.text)
        }
      })
      return resultText.join(', ');
    },
    hasDiffs() {
      return !_.isEqual(this.o, this.n)
    },
  }
}
</script>
<style scoped>
.specField {
  border: 1px solid #b0b4b4 !important;
  border-radius: 3px;
  cursor: pointer;
}
</style>
